import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Badge, Tag, Table } from 'antd';
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import { decode } from 'html-entities';
import { getUIStatus } from 'HELPERS/utils';
import { fetchReportData } from 'ACTIONS/reports.actions';
import { getReportStatusByName } from 'HELPERS/reports';
import queryString from 'query-string';
import Linkify from 'react-linkify';
import './ReportsPage.less';

class ReportsTable extends Component {
  componentDidMount() {
    const { location } = this.props.router;
    const queryParams = this.getQueryParams();
    const urlSearch = new URLSearchParams(location.search);
    const query = {
      ...queryParams,
      created_at: this.props.currentMonthDate,
    };

    if (!urlSearch.has('campaign_status_id')) {
      // Default filter is problem.
      query.campaign_status_id = getReportStatusByName('problem').id;
    }

    this.props.fetchReportData(query);
  }

  getQueryParams = () => {
    const { location } = this.props.router;
    return queryString.parse(location.search);
  }

  getColumns = () => {
    const { location } = this.props.router;
    const params = this.getQueryParams();
    const urlSearch = new URLSearchParams(location.search);

    const columns = [
      {
        title: 'Site Name',
        dataIndex: 'account',
        key: 'accounts.name',
        render: account => (
          <a target="_blank" rel="noreferrer" title="Access website" href={`http://${account.site}`}>
            {decode(account.name)}
          </a>
        ),
        width: 130,
        sorter: true,
      },
      {
        title: 'Client',
        dataIndex: 'account',
        key: 'clients.name',
        render: ({ clients }) => (clients)
          && clients.map(client => (
            <Tag style={{ cursor: 'pointer' }} key={`client_${client.id}`} onClick={this.filterClient(client.id)}>
              {decode(client.name) || (client.cap_client_id || client.id)}
            </Tag>
          )),
        sorter: true,
      },
      {
        title: 'MailChimp Account',
        dataIndex: 'account',
        key: 'account.mailchimp_account',
        render: account => account.mailchimp_account,
      },
      {
        title: 'Mail List Name',
        dataIndex: 'mailchimp_list_name',
        key: 'mailchimp_list_name',
        width: 160,
      },
      {
        title: 'Subscribers',
        dataIndex: 'mailchimp_list_subscribers',
        key: 'mailchimp_list_subscribers',
        width: 136,
        sorter: true,
      },
      {
        title: 'Status',
        dataIndex: 'campaign_status',
        key: 'campaign_status_id',
        width: 110,
        // eslint-disable-next-line
        render: ({ status }) => <Badge key="status_badge" status={getUIStatus(status)} text={status} />,
        sorter: true,
      },
      {
        title: 'Details',
        dataIndex: 'details',
        key: 'details',
        // eslint-disable-next-line
        render: ( details ) => (
          <Linkify key="details_linkify" properties={{ target: '_blank' }}>
            {details}
          </Linkify>),
        sorter: true,
      },
      {
        title: 'Last Update',
        dataIndex: 'updated_at',
        width: 190,
        key: 'updated_at',
        render: value => moment(value).format('LLL'),
        sorter: true,
      },
    ];

    return columns.map(column => ({
      ...column,
      sortOrder: (urlSearch.has('sort') && urlSearch.has('direction') && params.sort === column.key) && `${params.direction}end`,
    }));
  }

  getData = () => {
    const { data } = this.props;
    // Avoid render a register which does not have the account object
    return data.filter(item => item.account);
  }

  handleTableChange = (pagination, filters, sorter) => {
    const { location } = this.props.router;
    const queryParams = queryString.parse(location.search);

    const query = {
      page: pagination.current,
    };

    if (Object.keys(sorter).length) {
      const { column } = sorter;
      query.sort = column.key;
      query.direction = sorter.order === 'ascend' ? 'asc' : 'desc';
    }

    return this.props.fetchReportData({
      ...queryParams,
      ...query,
    });
  }

  filterClient = id => () => {
    const { location } = this.props.router;
    const queryParams = queryString.parse(location.search);

    const query = {
      client_id: id,
    };

    return this.props.fetchReportData({
      ...queryParams,
      ...query,
      page: 1,
    });
  }

  render() {
    const {
      total,
      currentPage,
      isLoading,
    } = this.props;

    const columns = this.getColumns();

    return (
      <div className="reports-table-container">
        <Table
          columns={columns}
          rowKey={record => record.id}
          dataSource={this.getData()}
          loading={isLoading}
          onChange={this.handleTableChange}
          pagination={{
            total,
            current: currentPage,
          }}
        />
      </div>
    );
  }
}

ReportsTable.propTypes = {
  fetchReportData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  currentMonthDate: PropTypes.string.isRequired,
  router: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  currentPage: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

const mapStateToProps = ({ reports, router }) => ({
  ...reports,
  router,
});

const enhanced = compose(
  connect(mapStateToProps, {
    fetchReportData,
  })
);

export default enhanced(ReportsTable);



// WEBPACK FOOTER //
// ./src/pages/Reports/ReportsTable.js